package uz.ferro.erp.feature.home.ui

import mui.icons.material.AssignmentTurnedIn
import mui.icons.material.Badge
import mui.icons.material.Logout
import mui.icons.material.People
import mui.icons.material.WhereToVote
import mui.material.Box
import mui.material.List
import mui.material.ListItem
import mui.material.ListItemButton
import mui.material.ListItemIcon
import mui.material.ListItemText
import mui.system.sx
import react.FC
import react.Props
import react.ReactNode
import react.useContext
import uz.ferro.erp.Colors
import uz.ferro.erp.NavigationContext
import uz.ferro.erp.feature.user.model.Role
import uz.ferro.erp.manager.AuthManager
import uz.ferro.erp.navigator.NavigationPage
import uz.ferro.erp.ui.VerticalLayout
import web.cssom.Auto
import web.cssom.Display
import web.cssom.JustifyContent
import web.cssom.number
import web.cssom.px

external interface HomeDrawerMenuProps : Props {
    var isCompactMode: Boolean
}

external interface MenuItemProps : Props {
    var item: HomeMenuItem
    var isCompactMode: Boolean
}

data class HomeMenuItem(
    val page: NavigationPage,
    val title: String,
    val icon: FC<*>,
    val roles: List<String>
)


val HomeDrawerMenu = FC<HomeDrawerMenuProps> { props ->

    val navigator = useContext(NavigationContext)
    var isCompactMode = props.isCompactMode

    val menu = listOf(
        HomeMenuItem(
            page = NavigationPage.VISIT,
            title = "Tashriflar",
            icon = WhereToVote,
            roles = listOf(
                Role.ADMIN,
                Role.TASK_MANAGER,
                Role.SALES_POINT_MANAGER
            ),
        ),
        HomeMenuItem(
            page = NavigationPage.CUSTOMER,
            title = "Mijozlar",
            icon = People,
            roles = listOf(
                Role.ADMIN,
                Role.TASK_MANAGER,
                Role.SALES_POINT_MANAGER
            ),
        ),
        HomeMenuItem(
            page = NavigationPage.USER,
            title = "Xodimlar",
            icon = Badge,
            roles = listOf(
                Role.ADMIN,
                Role.TASK_MANAGER,
                Role.SALES_POINT_MANAGER
            ),
        ),
        HomeMenuItem(
            page = NavigationPage.TASK,
            title = "Vazifalar",
            icon = AssignmentTurnedIn,
            roles = listOf(
                Role.ADMIN,
                Role.TASK_MANAGER
            ),
        )
    ).filter {
        val role = AuthManager.role
        role != null && it.roles.contains(role.name)
    }

    VerticalLayout {
        sx {
            flexGrow = number(1.0)
            flexShrink = number(1.0)
        }

        List {
            menu.forEach { menuItem ->
                MenuItemView {
                    item = menuItem
                    this.isCompactMode = isCompactMode
                }
            }
        }

        Box {
            sx {
                flexGrow = number(1.0)
                flexShrink = number(1.0)
            }
        }

        List {
            ListItemButton {
                sx {
                    minHeight = 48.px
                    justifyContent = if (isCompactMode) JustifyContent.center else JustifyContent.start
                }

                ListItemIcon {
                    sx {
                        minWidth = 0.px
                        marginRight = if (isCompactMode) Auto.auto else 3.px
                        justifyContent = JustifyContent.center
                    }

                    Logout {
                        sx {
                            color = Colors.drawerContrastColor
                        }
                    }
                }

                if (isCompactMode.not()) {
                    ListItemText {
                        sx {
                            marginLeft = 16.px
                        }
                        primary = ReactNode("Chiqish")
                    }
                }

                onClick = {
                    AuthManager.logout()
                    navigator.openLogin()
                }
            }
        }
    }
}

val MenuItemView = FC<MenuItemProps> { props: MenuItemProps ->
    val navigator = useContext(NavigationContext)
    val menuItem = props.item
    val isCompactMode = props.isCompactMode

    ListItem {
        key = menuItem.title
        sx {
            display = Display.block
        }

        ListItemButton {
            sx {
                minHeight = 48.px
                justifyContent = if (isCompactMode) JustifyContent.center else JustifyContent.start
            }

            onClick = {
                navigator.openPage(menuItem.page)
            }

            ListItemIcon {
                sx {
                    minWidth = 0.px
                    justifyContent = JustifyContent.center
                }

                menuItem.icon {
                    sx {
                        color = Colors.drawerContrastColor
                    }
                }
            }

            if (isCompactMode.not()) {
                ListItemText {
                    sx {
                        marginLeft = 16.px
                    }
                    primary = ReactNode(menuItem.title)
                }
            }
        }
    }


}
